import "./Css/app.css";
import "./Css/tabs.css";
import "./Css/step.css";
import "./Css/snack.css";
import "./Css/window.css";
import "./Css/Calendar.css";
import "./Css/chat.css";
import "./Css/coupons.css";
import "./Css/agent.css";
import "./Css/new.css";
import "./Css/menu.css";
import "./Css/ClearableTextInput.tf.css";

import { NumberInput, TextInput, Select, ModalWindow, Root, MultilineInput, HashRef, Div, Checkbox, Span, DestroyingPatternContentSwitcher } from "@tblabs/truffle";
import moment from "moment";
import "moment/locale/pl";
import { DateTimeProvider } from "./Services/DateTimeProvider";
import { Router } from "./Services/Router";
import { OrderGeneratorPage } from "./Pages/OrderGeneratorPage";
import { OrdersManager } from "./Services/Storage/OrdersManager";
import { OrderConverter } from "./Services/Converters/Order/OrderConverter";
import { Agent, AgentsConverter, AgentsProvider } from "./Services/Agents/AgentsProvider";
import { StepFactory } from "./Services/StepFactory";
import { OrdersViewPage } from "./Pages/Admin/OrdersView/OrdersViewPage";
import { CustomerOrderViewPage } from "./Pages/Customer/CustomerOrderViewPage";
import { AdminOrderViewPage } from "./Pages/Admin/OrderView/AdminOrderViewPage";
import { TicketToOrderConverter } from "./Services/Storage/TicketToOrderConverter";
import { Ticket } from "./Models/Ticket";
import { AdminOrderRawEditPage } from "./Pages/Admin/OrderEdit/AdminOrderRawEditPage";
import { AdminOrderEditPage } from "./Pages/Admin/OrderEdit/AdminOrderEditPage";
import { LoginPage } from "./Pages/AdminLoginPage";
import { EmailSender } from "./Services/Notifier/EmailSender";
import { Notifier } from "./Services/Notifier/Notifier";
import { Box } from "./Components/Utils/Box";
import { EnvDetector } from "./Services/EnvDetector";
import { TopPanel } from "./Components/TopPanel";
import { BitcoinPriceProvider } from "./Steps/Payment/Services/BitcoinPriceProvider";
import { Env } from "./Models/Env";
import { ExpansesConverter } from "./Services/Storage/ExpansesRepo";
import { ExpensesPage } from "./Pages/Admin/ExpensesPage";
import { ExpansesProvider } from "./Pages/Admin/ExpansesProvider";
import { Center } from "./Components/Utils/Center";
import { DateTimeEditInput } from "./Components/Utils/DateSlider";
import { IStorageUser, ObjectDataset, ObjectDatasets, OnlineStorage } from "@tblabs/storage";
import { ShopContent } from "./Shop/ShopContent";
import { ShopConverter } from "./Shop/ShopConverter";
import { Order } from "./Models/Order";
import { TicketsRepo } from "./Services/Storage/TicketsRepo";
import { LoginFormLogic } from "./Services/Auth/LoginFormLogic";
import { InfoBox } from "./Components/InfoBox";
import { AgentsPage } from "./Pages/AgentsPage";
import { AgentOrdersViewPage } from "./Pages/Agent/AgentOrdersViewPage";
import { OrdersFolders } from "./Models/OrdersFolders";
import { Expanse } from "./Models/Expanse";
import { ErrorBox } from "./Pages/Customer/ErrorBox";


moment?.locale('pl')

NumberInput.DefaultCssClasses = "uk-input uk-form-width-small";
TextInput.DefaultCssClasses = "uk-input";
Select.DefaultCssClasses = "uk-select";
ModalWindow.DefaultCssClasses = "tf-modal-window";
ModalWindow.Hook = Root.Hook;
MultilineInput.DefaultCssClasses = "uk-textarea";


(async () =>
{
    const root = new Root("body");

    try
    {
        const _env = new EnvDetector();

        console.log("Environment: ", _env.Env, ", Clock: ", DateTimeProvider.Now);

        let storage;

        if (_env.Env === Env.Prod)
        {
            window.localStorage.setItem("app-rtc-fake", "false");
            window.localStorage.setItem("orders-set", OrdersFolders.Open);
            storage = "https://storage.specteam.pl/v5/";
        }
        else if (_env.Env === Env.Stage)
        {
            window.localStorage.setItem("app-rtc-fake", "false");
            window.localStorage.setItem("orders-set", OrdersFolders.Open);
            storage = "https://stage.storage.specteam.pl/v5/";
        }
        else if (_env.Env === Env.Local)
        {
            DateTimeProvider.UseFake(moment("2025-02-05 12:00:00").toDate());
            DateTimeProvider.UseFakeSwitch.Storable("app-rtc-fake")
            DateTimeProvider._now.Storable("app-rtc").OnChange(v => pagesSwitcher.Refresh())

            storage = "http://localhost/storageV5/";
        }

        const db = "Specteam";
        const _storage = new OnlineStorage(storage, db);

        const _shopConverter = new ShopConverter();
        const _shopRepo = new ObjectDataset<ShopContent>(_storage, "Shop", _shopConverter);

        const _agentsRepo = new ObjectDataset<Agent>(_storage, "Agents", new AgentsConverter());
        const _agents = new AgentsProvider(_agentsRepo);
        await _agents.Init();

        const _stepFactory = new StepFactory(_agents);
        const _orderConverter = new OrderConverter(_stepFactory);
        const _orders = new ObjectDatasets<Order>(_storage, ["OpenOrders", "ClosedOrders"], _orderConverter);

        const _ticketConverter = new TicketToOrderConverter(_stepFactory);
        const _ticketsRepo = new ObjectDataset<Ticket>(_storage, "Tickets");
        const _bitcoinPriceProvider = new BitcoinPriceProvider();
        const _tickets = new TicketsRepo(_ticketsRepo, _ticketConverter, _bitcoinPriceProvider);

        const _loginLogic = new LoginFormLogic(_storage)
            .OnLogin((user: IStorageUser, autologin: boolean) =>
            {
                if (user.Role.toLowerCase().startsWith("admin"))
                {
                    window.location.hash = "orders";
                }
            })
            .OnLogout(() =>
            {
                _loginLogic.ClearLoginInfo();
                // window.location.hash = "/";
            })

        await _loginLogic.TryAutoLogin();

        const _emailSender = new EmailSender();
        const _notifier = new Notifier(_emailSender, _env);

        const hash = new HashRef().Storable("hash");
        const _router = new Router(hash);

        const _manager = new OrdersManager(_orders, _tickets, _notifier);

        const pagesSwitcher = new DestroyingPatternContentSwitcher(hash)
            .AddContent("login", () => new LoginPage(_loginLogic))
            .AddContent("order/:orderId", ({ orderId }) => new CustomerOrderViewPage(_manager, orderId))
            .AddContent("agent/:agentId/tasks", ({ agentId }) => new AgentOrdersViewPage(_manager, _agents, agentId))

        const _expansesRepo = new ObjectDataset<Expanse[]>(_storage, "Expanses", new ExpansesConverter());
        const _expansesProvider = new ExpansesProvider(_expansesRepo);

        pagesSwitcher
            .AddContent("admin/agents", () => new AgentsPage(_router, _agents))
            .AddContent("orders", () => new OrdersViewPage(_manager, _router, _agents))
            .AddContent("admin/expanses", () => new ExpensesPage(_expansesProvider))
            .AddContent("order-creation/:id", ({ id }) => new OrderGeneratorPage(_manager, _stepFactory, _shopRepo, id))
            .AddContent("order-creation", () => new OrderGeneratorPage(_manager, _stepFactory, _shopRepo))
            .AddContent("admin/order/view/:orderId", ({ orderId }) => new AdminOrderViewPage(_manager, _router, _agents, orderId))
            .AddContent("admin/order/raw/:orderId", ({ orderId }) => new AdminOrderRawEditPage(_manager, orderId))
            .AddContent("admin/order/edit/:orderId", ({ orderId }) => new AdminOrderEditPage(_manager, _router, _stepFactory, _shopRepo, orderId))
    
        pagesSwitcher.AddDefaultContent(() => new InfoBox("Błędny adres", "Nic tu nie ma lub nie jesteś zalogowany"))

        pagesSwitcher.Refresh()

        root.Class("main").Append(
            (_storage.IsAuthorized && _env.Env === Env.Prod && window.location.origin.includes("localhost")) &&
            new Center(
                new InfoBox("⚠️ Produkcyjne dane na środowisku testowym", "Uwaga! Jesteś w środowisku testowym, ale załadowane są dane z produkcji. Wszystkie zmiany będą widoczne dla klientów.").Margin(0),
                new Checkbox(DateTimeProvider.UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(),
                new DateTimeEditInput(DateTimeProvider._now).DisplayInlineBlock(),
            ),

            (_storage.IsAuthorized && _env.Env === Env.Stage) &&
            new Box(
                new Span("@ " + _env.Env).FontSize(22).MarginRight(32),
                new Checkbox(DateTimeProvider.UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(),
                new DateTimeEditInput(DateTimeProvider._now).DisplayInlineBlock().Background("#222").Color("#eee"),
            ).Background("#111").Color("#eee").Padding(8).WidthPercent(100),

            _storage.IsAuthorized &&
            new TopPanel(_storage, _router),
            new Div("main__container").Append(
                pagesSwitcher,
            ),
        )
    }
    catch (error: any)
    {
        console.error(error);
        root.Append(new ErrorBox("Błąd", error.message));
    }
})()
